import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { DeviceService } from '../_services';
import * as DeviceActions from '../_actions/device';

@Injectable({
  providedIn: 'root',
})
export class DeviceEffects {
  loadDevices$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.loadDevices),
      mergeMap(() =>
        this.deviceService.getDevices().pipe(
          map((devices) => DeviceActions.loadDevicesSuccess({ devices })),
          catchError((error) => of(DeviceActions.loadDevicesFailure({ error })))
        )
      )
    )
  );

  addDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.addDevice),
      mergeMap(({ device }) =>
        this.deviceService.saveDevice(device).pipe(
          map((savedDevice) => DeviceActions.addDeviceSuccess({ device: savedDevice })),
          catchError((error) => of(DeviceActions.addDeviceFailure({ error })))
        )
      )
    )
  );

  updateDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.updateDevice),
      mergeMap(({ device }) =>
        this.deviceService.saveDevice(device).pipe(
          map((updatedDevice) => DeviceActions.updateDeviceSuccess({ device: updatedDevice })),
          catchError((error) => of(DeviceActions.updateDeviceFailure({ error })))
        )
      )
    )
  );

  deleteDevice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DeviceActions.deleteDevice),
      mergeMap(({ id }) =>
        this.deviceService.deleteDevice(id).pipe(
          map(() => DeviceActions.deleteDeviceSuccess({ id })),
          catchError((error) => of(DeviceActions.deleteDeviceFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private deviceService: DeviceService
  ) {}
}
